export enum Routes {
  About = 'About',
  CookiePolicy = 'CookiePolicy',
  Home = 'Home',
  PrivacyPolicy = 'PrivacyPolicy',
  Search = 'Search',
  Support = 'Support'
}
